import ZebraBrowserPrintWrapper from "zebra-browser-print-wrapper";

export async function getZebraPrinter() {
  try {
    // Create a new instance of the object
    const browserPrint = new ZebraBrowserPrintWrapper();

    // Select default printer
    const defaultPrinter = await browserPrint.getDefaultPrinter();

    // Set the printer
    browserPrint.setPrinter(defaultPrinter);

    // Check printer status
    const printerStatus = await browserPrint.checkPrinterStatus();

    return printerStatus;
  } catch (error: any) {
    return {
      isReadyToPrint: false,
      errors: "Error Connecting to Zebra Printer",
    };
  }
}

export async function PrintBarcode(workArea: string, sid: string) {
  try {
    sid = sid.padStart(5, " ");

    //today with sort label date format
    const newDate = new Date().toLocaleDateString("en-US", {
      year: "2-digit",
      month: "2-digit",
      day: "2-digit",
    });

    const data_to_send = JSON.stringify(
      "�CT~~CD,~CC^~CT~^XA~TA000~JSN^LT0^MNW^MTT^PON^PMN^LH0,0^JMA^PR3,3~SD30^JUS^LRN^CI0^XZ^XA^MMT^PW406^LL0203^LS0^FT65,173^A0N,102,100^FH^FDSID^FS^FT15,59^A0N,41,40^FH^FDWORKAREA^FS^FT247,59^A0N,41,40^FH^FDDATE^FS^PQ1,0,1,Y^XZ"
    )
      .replace("WORKAREA", workArea)
      .replace("SID", sid)
      .replace("DATE", newDate);

    // Create a new instance of the object
    const browserPrint = new ZebraBrowserPrintWrapper();

    // Select default printer
    const defaultPrinter = await browserPrint.getDefaultPrinter();

    // Set the printer
    browserPrint.setPrinter(defaultPrinter);

    // Check printer status
    const printerStatus = await browserPrint.checkPrinterStatus();

    // Check if the printer is ready
    if (printerStatus.isReadyToPrint) {
      browserPrint.print(data_to_send);
    } else {
      console.log("Error/s", printerStatus.errors);
    }
  } catch (error: any) {
    //console.log(error);
  }
}
